import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {$translate} from "../../services/internationalization/localize.service";

@Component({
  selector: 'sb-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {
  searchText: string = "";
  searchSitePlaceholderLabel = "";

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.searchSitePlaceholderLabel = $translate("ng.component.search-bar.search-site")`Search site`;
  }

  focusSearch() {
    this.searchText = "";
    document.getElementById("searchText").focus();
  }

  search() {
    const searchText = (this.searchText == null) ? "" : this.searchText.trim();
    this.router.navigateByUrl(`/Search?searchText=${encodeURIComponent(this.searchText)}`);
    this.clearSearch()
  }

  clearSearch() {
    document.getElementById("searchText").blur();
    this.searchText = "";
  }

  onKeyDown(e: KeyboardEvent) {
    if (e.key == 'Escape') {
      this.clearSearch();
    }
  }
}
